import React from "react";


function Footer() {
    


return(
    <footer className="footer">
        <a  href="https://www.linkedin.com/in/styrlingmorris/">
        <img className = 'links' src='/linkedinicon.png' alt="Logo" />
        </a>
        <a href="https://github.com/Styrlingjohn">
        <img className = 'links' src="/githubicon.png" alt='Logo' />
        </a>
    </footer>
)
};


export default Footer;

